import { Family } from '../types/family';

export function namesOf(family: Family, ids: string[]): string {
  return ids
    .map((id) => family.members.find((m) => m.id === id)?.name)
    .filter(Boolean)
    .join(', ');
}
